export default {
  "container": "_container_1bqgb7",
  "hover-state": "_hover-state_1bqgb7",
  "file-icon": "_file-icon_1bqgb7",
  "preview": "_preview_1bqgb7"
};